var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".bucks-back-total-summary[data-v-7]{text-align:center}.bucks-back-total-summary .bucks-back-total[data-v-7],.bucks-back-total-summary .icon-bucks[data-v-7]{color:#53a318}.bucks-back-total-summary .icon-bucks[data-v-7]{font-size:5em;line-height:0}.bucks-back-total-summary .bucks-back-total[data-v-7]{font-size:2.5em;font-weight:700}.bucks-back-total-summary h4[data-v-7]{margin-top:6px}.is-touch .bucks-back-total-summary .icon-bucks[data-v-7]{font-size:48px;padding-top:9px}.is-touch .bucks-back-total-summary .bucks-back-total[data-v-7]{font-size:1.714285em;font-weight:700;letter-spacing:.08em;line-height:1.167}.is-touch .bucks-back-total-summary h4[data-v-7]{color:#75787b;font-size:.928571em;font-weight:300;line-height:1.38462;margin-top:0}.is-touch .bucks-back-total-summary a[data-v-7]{display:block;margin-top:6px}")
;(function(){var Vue;

Vue = require('vue');

Vue.use(require('vue2-filters'));

module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  props: {
    apiBaseUrl: String,
    isTouchRequest: Boolean,
    totalEarnedTextKey: {
      type: String,
      "default": 'js.modules.rewards.common.groupon_bucks_earned'
    },
    showAllBucksLink: {
      type: Boolean,
      "default": true
    }
  },
  inheritAttrs: false,
  data: function() {
    return {
      totalBucksBack: 0
    };
  },
  created: function() {
    return $.getJSON(this.apiBaseUrl + "/api/reward-transactions/total-bucksback").done((function(_this) {
      return function(res) {
        var ref;
        return _this.totalBucksBack = (ref = res.data) != null ? ref.totalBucksBack : void 0;
      };
    })(this));
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',{staticClass:"bucks-back-total-summary"},[_c('div',{staticClass:"icon-bucks"}),_v(" "),_c('h4',[_v(_s(t(totalEarnedTextKey)))]),_v(" "),_c('div',{staticClass:"bucks-back-total"},[_v(_s(_f("currency")(totalBucksBack)))]),_v(" "),(showAllBucksLink && !isTouchRequest)?_c('a',{attrs:{"href":t('js.modules.rewards.common.groupon_bucks_link_url')}},[_v("\n    "+_s(t('js.modules.rewards.common.groupon_bucks_link_text'))+"\n  ")]):_e()])}}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-7"
